import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const fontFamily = "'Inter', 'Segoe UI', sans-serif";

const makeFill = (rgb) => (context) => {
  const { chart } = context;
  const { ctx, chartArea } = chart;
  if (!chartArea) return `rgba(${rgb}, 0.12)`;
  const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
  gradient.addColorStop(0, `rgba(${rgb}, 0.18)`);
  gradient.addColorStop(1, `rgba(${rgb}, 0)`);
  return gradient;
};

const data = {
  labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  datasets: [
    {
      label: "First",
      data: [33, 53, 85, 41, 44, 65, 72, 78, 55, 60, 50, 69],
      fill: true,
      backgroundColor: makeFill('225, 90, 106'),
      borderColor: '#e15a6a',
      pointBackgroundColor: '#e15a6a',
      pointHoverBackgroundColor: '#e15a6a',
      tension: 0.4,
      pointRadius: 3,
      pointHoverRadius: 5,
      pointBorderColor: '#ffffff',
      pointBorderWidth: 1.5,
      pointHoverBorderWidth: 2,
      pointHoverBorderColor: '#ffffff',
      borderWidth: 2.5
    },
    {
      label: "Second",
      data: [33, 25, 35, 51, 54, 76, 70, 80, 65, 60, 45, 68],
      fill: true,
      backgroundColor: makeFill('15, 159, 134'),
      borderColor: '#0f9f86',
      pointBackgroundColor: '#0f9f86',
      pointHoverBackgroundColor: '#0f9f86',
      tension: 0.4,
      pointRadius: 3,
      pointHoverRadius: 5,
      pointBorderColor: '#ffffff',
      pointBorderWidth: 1.5,
      pointHoverBorderWidth: 2,
      pointHoverBorderColor: '#ffffff',
      borderWidth: 2.5
    }
  ]
};

const options = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    mode: 'index',
    intersect: false
  },
  plugins: {
    legend: {
      position: 'top',
      align: 'end',
      labels: {
        usePointStyle: true,
        pointStyle: 'circle',
        boxWidth: 8,
        boxHeight: 8,
        padding: 16,
        color: '#3d564f',
        font: {
          family: fontFamily,
          size: 12,
          weight: 600
        }
      }
    },
    tooltip: {
      backgroundColor: '#102824',
      titleColor: '#d7f5ee',
      bodyColor: '#ffffff',
      padding: 12,
      cornerRadius: 10,
      displayColors: true,
      callbacks: {
        label(context) {
          return ` ${context.dataset.label}: ₹${context.parsed.y}`;
        }
      }
    }
  },
  scales: {
    x: {
      grid: { display: false },
      border: { display: false },
      ticks: {
        color: '#6b7f7a',
        font: { family: fontFamily, size: 12 }
      }
    },
    y: {
      grid: {
        color: 'rgba(16, 40, 36, 0.06)',
        drawTicks: false
      },
      border: { display: false },
      ticks: {
        color: '#6b7f7a',
        padding: 8,
        font: { family: fontFamily, size: 12 },
        callback(value) {
          return `₹${value}`;
        }
      }
    }
  }
};

const LineGraph = () => {
  return (
    <div className="krv-line-chart">
      <Line data={data} options={options} />
    </div>
  );
};

export default LineGraph;
